export default {
  name: 'Cargo',

  computed: {
    cargoCreateConfig () {
      return {
        title: this.$t('fleet/vehicle.cargo_space'),
        key: 'cargo',
        validationErrors: this.validationErrors,
        tabContent: [
          {
            title: this.$t('fleet/vehicle.cargo_space'),
            component: this.columnsContentComponent,
            rows: [
              {
                columnsCount: 4,
                fields: [
                  {
                    key: 'cargo_space_pallets',
                    label: this.$t('fleet/vehicle.cargo_space_pallets'),
                    field_type: 'number',
                    visible: true,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'cargo_space_width',
                    label: this.$t('fleet/vehicle.cargo_space_width'),
                    field_type: 'number',
                    visible: true,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'cargo_space_length',
                    label: this.$t('fleet/vehicle.cargo_space_length'),
                    field_type: 'number',
                    visible: true,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'cargo_space_height',
                    label: this.$t('fleet/vehicle.cargo_space_height'),
                    field_type: 'number',
                    visible: true,
                    editable: true,
                    creatable: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
